var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocumentHistory = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.1 2.5A2.1 2.1 0 0 0 2 4.6v12.6c0 1.16.94 2.1 2.1 2.1h5.134a7.003 7.003 0 0 1 5.366-8.66V8.185a2.1 2.1 0 0 0-.615-1.485L10.4 3.115A2.1 2.1 0 0 0 8.915 2.5zm1.05 7.35a1.05 1.05 0 1 0 0 2.1h4.2a1.05 1.05 0 1 0 0-2.1zM4.1 15.1c0-.58.47-1.05 1.05-1.05h2.1a1.05 1.05 0 1 1 0 2.1h-2.1c-.58 0-1.05-.47-1.05-1.05",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.8 22.9a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m1-8.25a1 1 0 1 0-2 0v2.75a1 1 0 0 0 .293.707l1.944 1.945a1 1 0 0 0 1.415-1.415L16.8 16.986z",
    clipRule: "evenodd"
  })));
};
export default SvgDocumentHistory;